import { useParams } from "react-router-dom";
import React from "react";
import NewsEventContainer from '../../../../containers/Print/default/News-Event'
export const PrintNewsEvent = (props)=>{
    let params=useParams();
    let id=params.id;
    document.getElementById("root").setAttribute("style","overflow:hidden");
    return (
        <NewsEventContainer id={id}/>
    )
}

export default PrintNewsEvent;